export default __webpack_public_path__ + "static/media/virtual-tryon.bea5d077.jpg";